import * as yup from "yup";
import { validationSchemas } from "./data";
export const productCategorySchema = yup.object().shape({
  productCategory: validationSchemas.name,
});
